import { Directive, EventEmitter, Output, inject } from "@angular/core";
import { NgControl } from "@angular/forms";
import { MatFormFieldControl } from "@angular/material/form-field";
import { Subject, distinctUntilChanged, takeUntil } from "rxjs";
import { FormControlService } from "../form-control.service";


@Directive({
    standalone: true,
    selector: '[matFormFieldCtrl]',
    providers: [
        { provide: MatFormFieldControl, useExisting: MatFormFieldCtrlImplDirective }
    ]
})
export class MatFormFieldCtrlImplDirective<T = any> implements MatFormFieldControl<T> {
    protected _formControlService = inject(FormControlService);
    public ngControl = inject(NgControl);

    protected _destroy = new Subject<void>

    @Output()
    readonly containerClick = new EventEmitter<void>();


    private _value: T | null = null
    get value() {
        return this._value
    }
    set value(value) {
        this._value = value;
    }

    static _counter = 1;

    static get counter() {
        return MatFormFieldCtrlImplDirective._counter++;
    }

    stateChanges = new Subject<void>();
    id: string;

    private _placeholder: string = ''
    get placeholder() {
        return this._placeholder
    }
    set placeholder(value: string) {
        this._placeholder = value;
    }

    private _focused: boolean = false;
    get focused() {
        return this._focused && !this.disabled
    }
    set focused(value: boolean) {

        this._focused = value;
        this.stateChanges.next();
    }

    get empty() {
        return !Boolean(this.value)
    }


    get shouldLabelFloat() {
        return this._focused || !this.empty;
    }

    private _required: boolean = false
    get required() {
        return this._required
    }
    set required(value: boolean) {
        this._required = value;
    }

    private _disabled: boolean = false
    get disabled() {
        return this._disabled
    }
    set disabled(value: boolean) {

        this._disabled = value;
    }

    private _errorState: boolean = false
    get errorState() {

        return this._errorState
    }
    set errorState(value: boolean) {

        this._errorState = value;
    }


    autofilled?: boolean;
    userAriaDescribedBy?: string;

    constructor() {

        this.id = 'ss-control-' + MatFormFieldCtrlImplDirective.counter;
        // this.required = Boolean(this._formControlService.formControl.validationRules.find(({ type }) => type === 'required'))
        this._formControlService.requiredObs
            .pipe(takeUntil(this._destroy))
            .subscribe((required) => {
                this.required = required;
                this.stateChanges.next();
            })

        this._formControlService.validationMessageSubject
            .pipe(takeUntil(this._destroy))
            .subscribe((validationMessage) => {
                this.errorState = Boolean(validationMessage);

                this.stateChanges.next();
            })

        this._formControlService.valueSubject
            .pipe(takeUntil(this._destroy))
            .subscribe((value) => {
                if (value !== this.value) {
                    this.value = value;
                    this.stateChanges.next();
                }
            })

        this._formControlService.readOnlyObs
            .pipe(
                takeUntil(this._destroy),
                distinctUntilChanged()
            )
            .subscribe((readOnly) => {

                this.disabled = readOnly;
                this.stateChanges.next();
            })

        this._formControlService.focusedSubject
            .pipe(
                takeUntil(this._destroy),
                distinctUntilChanged()
            )
            .subscribe((focused) => {
                this.focused = focused;
            })
    }

    setDisabledState?(isDisabled: boolean): void {
        this.disabled = isDisabled;

    }

    protected _describedByIds: string[] = []
    setDescribedByIds(ids: string[]): void {
        this._describedByIds = ids;
    }

    onContainerClick(event: MouseEvent) {
        this._formControlService.focus();
        this.containerClick.emit()
    }


}
